export const forgetpassword = {
    forgetpassword: 'ลืมรหัสผ่าน',
    please_input_phone: 'กรุณากรอกเบอร์โทรศัพท์ที่ลงทะเบียนไว้',
    changepassword: 'เปลี่ยนรหัสผ่านใหม่',
    success: 'ตั้งค่ารหัสผ่านใหม่สำเร็จ'
}
